import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiKeyboardArrowRight = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z" />
  </SvgWrapper>
)